import { Node } from "../node";

export class QuestionNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "QuestionNode",

      title: undefined,
      message: undefined,

      inputType: undefined,

      answers: [],
      selectedAnswerId: undefined,
    };
  }

  get currentState() {
    return { selectedAnswerId: this.selectedAnswerId };
  }

  get context() {
    return {
      [`question-${this.id}`]: this.selectedAnswer,
    };
  }

  get possibleNextNodeIds() {
    return this.answers.map((answer) => answer.targetNodeId);
  }

  get selectedAnswer() {
    return this.answers.find((answer) => answer.id === this.selectedAnswerId);
  }

  get isRadioInputType() {
    return this.inputType === "radio";
  }

  beforeShow(context) {
    this.selectedAnswerId = context[`question-${this.id}`]?.id;
  }

  autoAdvance(context) {
    // If we've already shown this question, we don't need to show it again
    return context[`question-${this.id}`];
  }

  nextNodeId() {
    return this.selectedAnswer?.targetNodeId;
  }

  reset() {
    this.selectedAnswerId = undefined;
  }
}
